import startOfDay from 'date-fns/startOfDay';
import subDays from 'date-fns/subDays';
import { formatDate } from 'helpers/date';

export const CHANGE_HISTORY_FEATURE_RELEASE_DATE = '28/11/2023';

export type ChangeHistoryFilterFormValues = {
  user_modifier: string;
  dates: string[];
};

export const initialChangeHistoryFilter: ChangeHistoryFilterFormValues = {
  user_modifier: '',
  dates: [formatDate(subDays(new Date(), 6), 'dd/MM/yyyy'), formatDate(new Date(), 'dd/MM/yyyy')]
};

const today = startOfDay(new Date());

export const calendarPreset = [
  {
    id: 'week',
    text: '7 dias',
    start: subDays(today, 6),
    end: today
  },
  {
    id: 'month',
    text: '30 dias',
    start: subDays(today, 29),
    end: today
  },
  {
    id: 'threeMonth',
    text: '90 dias',
    start: subDays(today, 89),
    end: today
  },
  {
    id: 'sixMonth',
    text: '180 dias',
    start: subDays(today, 179),
    end: today
  }
];

export const initialPagination = {
  page: 0,
  perPage: 10
};

export type ProductData = {
  id: number;
  title: string;
};
